export const TOKEN_TTL_MS = 22 * 1000 * 60; // token expires on server in 25 mins
export const SESSION_TTL_MS = 10 * 1000 * 60; // how long pending to warn user that session is about to end
export const SESSION_MID_TTL_MS = 10 * 1000 * 60; // how long before we trigger an API call to keep the token expiration time updated
export const AUTO_SAVE_TIMER_MS = 8 * 1000 * 60; // how long before we warn user to auto save the template
export const TIMEOUT_MODAL_WARNING_SECONDS = 120; // how long to show warn modal before ending session
export const POLLING_ENDPOINT_TIMER_MS = 5 * 1000; // how often recipient count for lists polling endpoint should be triggered
export const DEFAULT_PAGE_SIZE = 999; // default page size for API calls that need to fetch all items

export const types = {
  TEMPLATE: 'TEMPLATE',
  ATTACHMENT_TEMPLATE: 'ATTACHMENT_TEMPLATE',
  QUERY_TEMPLATE: 'QUERY_TEMPLATE',
  SURVEY_TEMPLATE: 'SURVEY_TEMPLATE'
};

export const licensePlan = {
  LICENSE_STANDARD_PLUS: 'LICENSE_STANDARD_PLUS',
  LICENSE_STANDARD_PLUS_PLUS: 'LICENSE_STANDARD_PLUS_PLUS',
  LICENSE_STANDARD: 'LICENSE_STANDARD',
  LICENSE_NONE: 'LICENSE_NONE',
  LICENSE_ALL: 'LICENSE_ALL'
};

export const licenseFeatures = {
  FEATURE_STANDARD: 'FEATURE_STANDARD',
  FEATURE_ON_DEMAND_CAMPAIGN: 'FEATURE_ON_DEMAND_CAMPAIGN',
  FEATURE_RECIPIENT_QUERIES: 'FEATURE_RECIPIENT_QUERIES',
  FEATURE_SURVEY: 'FEATURE_SURVEY',
  FEATURE_PRINT: 'FEATURE_PRINT',
  FEATURE_NONE: 'FEATURE_NONE',
  FEATURE_ALL: 'FEATURE_ALL',
  FEATURE_BASIC: 'FEATURE_BASIC'
};

export const listManagementProduct = {
  SCHEMA_NAME: 'List Management Schema'
};

export const guestInsightProduct = {
  SCHEMA_NAME: 'Guest Insight Schema'
};

export const ProductType = {
  Product: 'EVENT',
  List: 'LIST',
  GUEST_INSIGHTS: 'GUEST_INSIGHT'
};

// title for navbar , its used for license check also
export const SideBarNavTitle = {
  AllCampaigns: 'All Campaigns',
  Attachments: 'Attachments',
  Campaigns: 'Campaigns',
  RecipientQueries: 'Recipient Queries',
  ConditionQueries: 'Condition Queries',
  Reports: 'Reports',
  Summary: 'Campaign Reports',
  UnSubscribe: 'Unsubscribe Reports',
  Events: 'Event Reports',
  Batches: 'Print Batches',
  Settings: 'Settings',
  Surveys: 'Surveys',
  SurveyResultResponseTemplates: 'Survey Result Response',
  Communication: 'Communication',
  Templates: 'Templates',
  Uploads: 'Uploads',
  PrintTemplates: 'Print',
  ListsAndSubscribers: 'Lists and Subscribers',
  Dashboard: 'Dashboard',
  GuestInsights: 'Guest Insights',
  Logout: 'Logout'
};

export const UnlayerProjectIds = {
  DefaultId: 103077,
  SecondaryId: 10105
};

export const campaignTableTitles = [
  {
    id: 'name',
    label: 'Name',
    hasTenantDefault: true,
    enableSort: true
  },
  { id: 'type', label: 'Type', enableSort: true },
  { id: 'sendDate', label: 'Send Date' },
  { id: 'actionButton', label: '' }
];

export const templateTableTitles = [
  {
    id: 'name',
    label: 'Template',
    hasTags: true,
    hasGlobalDefault: true,
    hasTenantDefault: true,
    enableSort: true
  },
  { id: 'type', label: 'Type', enableSort: true },
  { id: 'actionButton', label: '' }
];

export const printTemplateTableTitles = [
  {
    id: 'name',
    label: 'Print Template',
    hasTags: true,
    hasGlobalDefault: true,
    hasTenantDefault: true,
    enableSort: true
  },
  { id: 'id', label: 'Template Id', hasCopy: true },
  { id: 'type', label: 'Type' },
  { id: 'actionButton', label: '' }
];

export const unSubscribeTableTitles = [
  { id: 'emailAddress', label: 'Email Address', enableSort: true },
  { id: 'allPromotionalCampaignsString', label: 'Promotional' },
  { id: 'allTransactionalCampaignsString', label: 'Transactional' },
  {
    id: 'excludedCampaigns',
    label: 'Excluded Campaigns',
    enableTooltip: true,
    tooltip: 'excludedCampaigns'
  },
  { id: 'actionButton', label: '' }
];

export const batchTableTitles = [
  { id: 'templateName', label: 'Template Name', enableSort: true },
  { id: 'type', label: 'Type' },
  { id: 'id', label: 'Batch Id', hasCopy: true },
  { id: 'status', label: 'Status', hasIcons: true, enableSort: true },
  { id: 'createTime', label: 'Created On', enableSort: true },
  { id: 'actionButton', label: '' }
];

export const eventReportsTableTitles = [
  { id: 'productName', label: 'Product Name', enableSort: true },
  { id: 'eventTypeCategory', label: 'Event Type Category', enableSort: true },
  { id: 'emailAddress', label: 'Email Address', hasLink: true },
  { id: 'createdOn', label: 'Created On', enableSort: true },
  { id: 'actionButton', label: '' }
];

export const eventHistoryTableTitles = [
  {
    id: 'campaignName',
    label: 'Campaign',
    hasLink: true,
    value: 'campaignUuid'
  },
  {
    id: 'templateName',
    label: 'Template',
    hasLink: true,
    value: 'communicationTemplateUuid'
  },
  { id: 'eventTime', label: 'Event Time' },
  { id: 'eventNotes', label: 'Event Notes' },
  { id: 'actionButton', label: '' }
];

export const attachmentTableTitles = [
  {
    id: 'name',
    label: 'Attachments',
    hasTags: true,
    hasGlobalDefault: true,
    hasTenantDefault: true,
    enableSort: true
  },
  { id: 'type', label: 'Type', enableSort: true },
  { id: 'actionButton', label: '' }
];

export const surveyTemplateTableTitles = [
  {
    id: 'name',
    label: 'Survey Result Response Template',
    hasTags: true,
    hasGlobalDefault: true,
    hasTenantDefault: true,
    enableSort: true
  },
  { id: 'actionButton', label: '' }
];

export const recipientQueriesTableTitles = [
  {
    id: 'name',
    label: 'Recipient Queries',
    hasTenantDefault: true,
    enableSort: true
  },
  { id: 'actionButton', label: '' }
];

export const conditionQueriesTableTitles = [
  {
    id: 'name',
    label: 'Condition Queries',
    hasTenantDefault: true,
    enableSort: true
  },
  { id: 'actionButton', label: '' }
];

export const surveyTableTitles = [
  {
    id: 'name',
    label: 'Surveys',
    hasTenantDefault: true,
    enableSort: true
  },
  { id: 'actionButton', label: '' }
];

export const schemaTableTitles = [
  { id: 'schemaName', label: 'Schema Name', enableSort: true },
  { id: 'eventProductCategory', label: 'Product Category', enableSort: true },
  { id: 'eventProductName', label: 'Product Name', enableSort: true },
  { id: 'eventTypeCategory', label: 'Event type Category' },
  { id: 'actionButton', label: '' }
];

export const enrichedSchemaTableTitles = [
  { id: 'schemaName', label: 'Enriched Schema Name', enableSort: true },
  { id: 'enrichmentProduct', label: 'Enrichment Product', enableSort: true },
  { id: 'actionButton', label: '' }
];

export const listTableTitles = [
  { id: 'name', label: 'List Name', enableSort: true, hasTenantDefault: true },
  { id: 'actionButton', label: '' }
];

export const subscriberTableTitles = [
  { id: 'name', label: 'Subscriber Name', enableSort: true },
  { id: 'emailId', label: 'Email Address', enableSort: true },
  { id: 'actionButton', label: '' }
];

export const segmentedListTitles = [
  { id: 'name', label: 'Segmented List name', enableSort: true },
  { id: 'actionButton', label: '' }
];

export const importStatusTitles = [
  { id: 'fileName', label: 'File Name' },
  { id: 'state', label: 'Status', isHoverLink: true },
  {
    id: 'errorFileName',
    label: 'Error File',
    isLink: true,
    linkId: 'errorFileId'
  },
  { id: 'updateTime', label: 'Last Updated Time' }
];

export const GuestInsightsTableTitles = [
  { id: 'firstName', label: 'Name' },
  { id: 'primaryEmailAddress', label: 'Email Address' },
  { id: 'actionButton', label: '' }
];

export const dynamicLayout = {
  maxRows: 4,
  maxColumns: 3
};

export const reportIdentifierData = [
  {
    productName: 'v12',
    eventTypeCategory: 'Reservation',
    fieldName: 'ReservationConfirmationNumber',
    columnName: 'Reservation Confirmation Number'
  },
  {
    productName: 'LMS2',
    eventTypeCategory: 'Reservation',
    fieldName: 'confirmationNumber',
    columnName: 'Confirmation Number'
  },
  {
    productName: 'LMS2',
    eventTypeCategory: 'Folio',
    fieldName: 'resId',
    columnName: 'Res Id'
  },
  {
    productName: 'Stay2',
    eventTypeCategory: 'Reservation',
    fieldName: 'confirmationCode',
    columnName: 'Confirmation Code'
  },
  {
    productName: 'Spa',
    eventTypeCategory: 'SpaAppointment',
    fieldName: 'confirmationId',
    columnName: 'Confirmation Id'
  },
  {
    productName: 'Golf',
    eventTypeCategory: 'GolfBooking',
    fieldName: 'confirmationNumber',
    columnName: 'Confirmation Number'
  }
];

export const supportedImageFormats = [
  'image/jpeg',
  'image/png',
  'image/svg+xml',
  'image/x-icon'
];

export const excludeSurveyTools = [
  'panel',
  'paneldynamic',
  'multipletext',
  'expression',
  'html',
  'matrixdropdown',
  'matrixdynamic',
  'signaturepad',
  'imagepicker',
  'image',
  'file'
];

// Default disabled attachment template types (can be overridden via ADM_DISABLED_ATTACHMENT_TYPES env var)
// Possible values: 'PDF', 'PNG', 'DOC'
export const disabledAttachmentTypes = [];

export const excludeProductNames = ['ListManagement', 'GuestInsight'];
export const excludeProductCategories = ['ADM'];

export const guestInfoValuesList = [
  { value: 'firstName', dataType: 'String', maxLength: 256 },
  { value: 'middleName', dataType: 'String', maxLength: 256 },
  { value: 'lastName', dataType: 'String', maxLength: 256 },
  { value: 'nameSuffix', dataType: 'String', maxLength: 64 },
  { value: 'nameSalutation', dataType: 'String', maxLength: 64 },
  { value: 'gender', dataType: 'String', maxLength: 32 }
];

export const contactInfoValuesList = [
  { value: 'primaryEmailAddress', dataType: 'String', maxLength: 256 },
  { value: 'primaryPhoneNumber', dataType: 'String', maxLength: 32 },
  { value: 'addressLine1', dataType: 'String', maxLength: 256 },
  { value: 'addressLine2', dataType: 'String', maxLength: 256 },
  { value: 'addressLine3', dataType: 'String', maxLength: 256 },
  { value: 'city', dataType: 'String', maxLength: 256 },
  { value: 'region', dataType: 'String', maxLength: 256 },
  { value: 'postalCode', dataType: 'String', maxLength: 256 },
  { value: 'countryCode', dataType: 'String', maxLength: 256 }
];

export const consentValuesList = [
  { value: 'emailPromotionalMessaging', dataType: 'Boolean' },
  { value: 'emailTransactionalMessaging', dataType: 'Boolean' },
  { value: 'smsPromotionalMessaging', dataType: 'Boolean' },
  { value: 'smsTransactionalMessaging', dataType: 'Boolean' }
];

export const dateRangeValuesList = [
  { value: 'birthDate', dataType: 'Date', label: 'Birth Date' },
  {
    value: 'weddingAnniversaryDate',
    dataType: 'Date',
    label: 'Wedding Anniversary'
  },
  { value: 'profileCreatedDate', dataType: 'Date', label: 'Profile Created' },
  { value: 'lastStayDate', dataType: 'Date', label: 'Last Stay' },
  {
    value: 'nextStayDate',
    dataType: 'Date',
    label: 'Next Stay',
    allowFutureDates: true
  },
  { value: 'lastSpaDate', dataType: 'Date', label: 'Last Spa' },
  {
    value: 'nextSpaDate',
    dataType: 'Date',
    label: 'Next Spa',
    allowFutureDates: true
  },
  { value: 'lastGolfDate', dataType: 'Date', label: 'Last Golf' },
  {
    value: 'nextGolfDate',
    dataType: 'Date',
    label: 'Next Golf',
    allowFutureDates: true
  },
  { value: 'lastDiningDate', dataType: 'Date', label: 'Last Dining' },
  {
    value: 'nextDiningDate',
    dataType: 'Date',
    label: 'Next Dining',
    allowFutureDates: true
  }
];

export const excludePathForLanguageCode = [
  '/templates/details',
  '/templates/design',
  '/attachment-templates/details',
  '/attachment-templates/design',
  '/print-templates/details',
  '/print-templates/design',
  '/surveyResultResponse-templates/details',
  '/surveyResultResponse-templates/design',
  '/unlayerEditor',
  '/unlayerAttachmentEditor',
  '/grapejsEditor'
];

export const resetFilterPaths = [
  '/campaigns',
  '/recipient-queries',
  '/templates',
  '/attachment-templates',
  '/print-templates',
  '/surveyResultResponse-templates',
  '/condition-queries',
  '/lists',
  '/guest-insights',
  '/unsubscribe',
  '/events',
  '/batches',
  '/surveys',
  '/schema',
  '/enriched-schema',
  '/reports',
  '/uploads'
];
